import React from "react";
import { Redirect } from "react-router-dom";
import { useCashbookStatus } from "../../../helpers/cashbookStatus";
import { canUseRounds, isKarkhanaSupervisor } from "../../../helpers/karkhanaEnabled";
import KarkhanaCashBookPage from "../KarkhanaCashBookPage";
import { kp } from "../karkhanaPaths";
import { CashSkeleton, readRole } from "./CashbookGuard";
import OwnerInbox from "./owner/OwnerInbox";
import SupervisorCashHome from "./supervisor/SupervisorCashHome";

/**
 * /karkhana/money/cash-book: today's cash book page unless the studio has the Cash book add-on
 * (V1_SPEC D2, 11.2). With it, supervisors get their नकद home and owners/managers the "To check" inbox.
 */
const CashBookRoute = () => {
  const role = readRole();
  const { enabled, loaded } = useCashbookStatus();
  if (!canUseRounds(role)) return <Redirect to={kp.home()} />;
  if (!loaded) return <CashSkeleton />;
  if (!enabled) return <KarkhanaCashBookPage />;
  return isKarkhanaSupervisor(role) ? <SupervisorCashHome /> : <OwnerInbox />;
};

export default CashBookRoute;
